<div class="searchfilterbar" [class.sidebar]="sidebar()">
  <!-- Search -->
  @if (!sidebar()) {
    <div
      class="search drop-shadow body-bold"
      [class.collapsed]="collapsed()"
      [class.open]="!collapsed()"
      [@expandCollapse]="collapsed() ? 'collapsed' : 'expanded'"
      [class.activeSearch]="
        assetsService.getSearchTerm() !== '' &&
        assetsService.getSearchTerm() !== null
      "
    >
      <div class="search-input-area">
        <button
          class="close-btn"
          aria-label="{{ i18n.langString('close_search') }}"
          (click)="collapse()"
        >
          <i nz-icon nzType="icons:exit" class="svg-icon fillwhite"></i>
        </button>
        <input
          enterkeyhint="search"
          #searchInput
          placeholder="{{ i18n.langString('find_equipment') }}"
          (focus)="$event.target.select()"
          (input)="onTextInput($event)"
          (keyup.enter)="search()"
        />
      </div>
      <button
        class="search-btn"
        aria-label="{{ i18n.langString('search') }}"
        (click)="collapsed() ? expand() : search()"
      >
        @if (
          !collapsed() ||
          assetsService.getSearchTerm() === "" ||
          assetsService.getSearchTerm() === null
        ) {
          <i
            nz-icon
            nzType="icons:search"
            class="svg-icon search-icon"
            [class.fillwhite]="collapsed()"
          ></i>
        }
        @if (
          collapsed() &&
          assetsService.getSearchTerm() !== "" &&
          assetsService.getSearchTerm() !== null
        ) {
          <i
            nz-icon
            nzType="icons:search-active"
            class="svg-icon search-icon noMarginRight multicolorIcon"
          ></i>
        }
        @if (collapsed()) {
          <span>{{ i18n.langString("search") }}</span>
        }
      </button>
      @if (
        collapsed() &&
        assetsService.getSearchTerm() !== "" &&
        assetsService.getSearchTerm() !== null
      ) {
        <button
          class="clear-btn"
          aria-label="{{ i18n.langString('close_search') }}"
          (click)="clearSearchTerm()"
        >
          <i nz-icon nzType="icons:exit" class="svg-icon"></i>
        </button>
      }
    </div>
  }

  @if (sidebar()) {
    <div
      class="search drop-shadow body-bold sidebar-search"
      [class.onlysearch]="onlysearch()"
    >
      @if (!onlysearch()) {
        <div class="search-title">
          <i nz-icon nzType="icons:search" class="svg-icon"></i>
          <h4>{{ i18n.langString("search") }}</h4>
          @if (
            onlysearch() || (searchInput.value && searchInput.value !== "")
          ) {
            <button
              class="clear-btn"
              aria-label="{{ i18n.langString('clear_search') }}"
              (click)="clearSearchTerm()"
            >
              @if (!searchInput.value || searchInput.value === "") {
                <i nz-icon nzType="icons:search" class="svg-icon"></i>
              }
              @if (searchInput.value && searchInput.value !== "") {
                <i nz-icon nzType="icons:exit" class="svg-icon"></i>
                <span class="body-bold underlineText">{{
                  i18n.langString("clear_search")
                }}</span>
              }
            </button>
          }
        </div>
      }
      <div
        class="search-input-area"
        [class.searchFilled]="searchInput.value && searchInput.value !== ''"
      >
        <input
          #searchInput
          placeholder="{{ i18n.langString('find_equipment') }}"
          (focus)="$event.target.select()"
          (input)="onTextInput($event)"
          (keydown)="search()"
          (keyup.enter)="search()"
        />
        @if (collapsed() && searchInput.value && searchInput.value !== "") {
          <button
            class="clear-btn"
            aria-label="Close Search"
            (click)="clearSearchTerm()"
          >
            <i nz-icon nzType="icons:exit" class="svg-icon fillwhite"></i>
          </button>
        }
      </div>
    </div>
  }

  <!-- Filter -->
  @if (!sidebar() && collapsed()) {
    <button
      class="filter drop-shadow body-bold"
      (click)="openFilter()"
      [class.active-filter]="filterCount() > 0"
    >
      @if (filterCount() === 0) {
        <i nz-icon nzType="icons:filter" class="svg-icon fillwhite"></i>
      }
      @if (filterCount() > 0) {
        <nz-badge
          [nzCount]="filterCount()"
          nzStandalone
          [nzStyle]="{ backgroundColor: '#5F6973', color: 'white' }"
        ></nz-badge>
      }
      <span>{{ i18n.langString("filter") }}</span>
      @if (filterCount() > 0) {
        <i
          nz-icon
          nzType="icons:exit"
          class="svg-icon clear-btn"
          (click)="clearFilter($event)"
        ></i>
      }
    </button>
  }

  @if (sidebar() && !onlysearch()) {
    <div class="filter sidebar-filter">
      <!-- Removed [sidebar]="true" to fix the error because in old code it's not found in Filter ts file  -->
      <app-filter
        (onChangeFilter)="onChangeFilter()"
        (closeFilter)="closeFilter()"
        [plantsFilter]="plantsFilter()"
        [notificationsFilter]="notificationsFilter()"
        [countryOrRegionSelected]="countryOrRegionSelected()"
        [plantFilterStatus]="plantFilterStatus()"
      ></app-filter>
    </div>
  }
</div>

<nz-modal
  [nzVisible]="filter_open()"
  (nzOnCancel)="closeFilter()"
  [nzFooter]="null"
  nzTitle="Filter"
  [nzCloseIcon]="closeIcon"
  [nzMaskClosable]="false"
  [nzContent]="modalContent"
>
  <ng-template #closeIcon>
    <img src="assets/icons/exit_new.svg" />
  </ng-template>
  <ng-template #modalContent>
    <app-filter
      (onChangeFilter)="onChangeFilter()"
      (closeFilter)="closeFilter()"
      [submit_btn]="true"
      [plantsFilter]="plantsFilter()"
      [plantFilterStatus]="plantFilterStatus()"
      [countryOrRegionSelected]="countryOrRegionSelected()"
    ></app-filter>
  </ng-template>
</nz-modal>
